import { Text, View } from '@react-pdf/renderer';
import { ISchedule } from '../../interfaces';
import * as S from './styles';
import { RHeader, RPage, RViewer } from '../../../components/PdfRender';
import { useCompany } from '../../../hooks/company';
import { formatDate } from '../../utils/format-date';

interface ISchedulesMissedReportProps {
  schedules: ISchedule[];
}
export const SchedulesMissedReport: React.FC<ISchedulesMissedReportProps> = ({
  schedules,
}) => {
  const { company } = useCompany();

  const renderData = () => {
    if (!schedules.length)
      return (
        <View style={[S.Styles.row, { fontSize: 11 }]}>
          <Text>Sem registros</Text>
        </View>
      );

    return (
      <View>
        <View style={S.Styles.rowHeader}>
          <Text style={S.Styles.columnHeader}>Data</Text>
          <Text style={S.Styles.columnHeader}>Hora</Text>
          <Text style={S.Styles.columnHeader}>Cliente</Text>
          <Text style={S.Styles.columnHeader}>Profissional</Text>
          <Text style={S.Styles.columnHeader}>Status</Text>
          <Text style={S.Styles.columnHeader}>Observação</Text>
        </View>
        {schedules?.map((item, index) => (
          <View
            key={item.id}
            style={[
              S.Styles.row,
              { backgroundColor: index % 2 === 0 ? '#fff' : '#E3E3E3' },
            ]}
          >
            <Text style={S.Styles.column}>{formatDate(item.start)}</Text>
            <Text style={S.Styles.column}>
              {formatDate(item.start, 'HH:mm')} -{' '}
              {formatDate(item.end, 'HH:mm')}
            </Text>
            <Text style={S.Styles.column}>{item.title}</Text>
            <Text style={S.Styles.column}>{item.professional_name}</Text>
            <Text style={S.Styles.column}>{item.description_status}</Text>
            <Text style={S.Styles.column}>{item.observation}</Text>
          </View>
        ))}
        <View style={S.Styles.rowHeader}>
          <Text style={S.Styles.columnTotal}>
            Total: {schedules.length ?? 0} agendamentos
          </Text>
        </View>
      </View>
    );
  };

  return (
    <RViewer>
      <RPage size={'A4'}>
        <View style={S.Styles.container}>
          <RHeader company={company} />
          <View style={S.Styles.headerTitle}>
            <Text>Relatório de Agendamentos</Text>
          </View>
          {renderData()}
        </View>
      </RPage>
    </RViewer>
  );
};
